/* ============================================================
   MARS JEWELERS — theme.js
   Vanilla JS: mobile menu, smooth anchors, reveal on scroll,
   header state. No frameworks.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Mobile menu toggle ---------- */
  var toggle = document.getElementById('menu-toggle');
  var menu = document.getElementById('mobile-menu');
  var closeBtn = document.getElementById('menu-close');

  function setMenu(open) {
    if (!toggle || !menu) return;
    document.body.classList.toggle('menu-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    menu.setAttribute('aria-hidden', String(!open));
  }

  if (toggle) {
    toggle.addEventListener('click', function () { setMenu(true); });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', function () { setMenu(false); });
  }
  if (menu) {
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setMenu(false); });
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setMenu(false);
  });

  /* ---------- Smooth anchor scrolling ---------- */
  function smoothTo(target) {
    var el = typeof target === 'string' ? document.querySelector(target) : target;
    if (!el) return false;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  // Same-page #anchors
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href');
      if (href.length > 1 && smoothTo(href)) {
        e.preventDefault();
        history.replaceState(null, '', href);
      }
    });
  });

  // /#anchors while already on the homepage (avoid a reload)
  document.querySelectorAll('a[href^="/#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (window.location.pathname === '/') {
        var id = a.getAttribute('href').slice(1);
        if (id.length > 1 && smoothTo(id)) {
          e.preventDefault();
          history.replaceState(null, '', id);
        }
      }
    });
  });

  /* ---------- Header state ---------- */
  var header = document.getElementById('site-header');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 24);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    // Fallback: show everything if IntersectionObserver is unavailable
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }
})();

/* ============================================================
   v2: Shop — cart drawer, product gallery, variants, qty
   ============================================================ */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');

  function setCartOpen(open) {
    if (!drawer || !overlay) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    overlay.hidden = !open;
    document.body.classList.toggle('cart-open', open);
    // retrigger reveal for freshly injected cards
    if (open && 'IntersectionObserver' in window) {
      drawer.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  }

  function renderCart(cart) {
    var itemsWrap = drawer.querySelector('[data-cart-items]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    var headerCount = document.querySelector('[data-header-cart-count]');
    var totalEl = drawer.querySelector('[data-cart-total]');

    countEls.forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
    if (headerCount) {
      headerCount.textContent = cart.item_count;
      headerCount.hidden = cart.item_count === 0;
    }
    if (totalEl) totalEl.textContent = money(cart.total_price);

    if (!cart.items.length) {
      itemsWrap.innerHTML = '<p class="cart-drawer-empty">Your cart is empty.</p>';
      return;
    }
    itemsWrap.innerHTML = cart.items.map(function (item, i) {
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-drawer-item-variant">' + esc(item.variant_title) + '</p>' : '';
      var img = item.image
        ? '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" width="120" height="120" loading="lazy">' : '';
      return '<div class="cart-drawer-item">' + img +
        '<div class="cart-drawer-info">' +
          '<p class="cart-drawer-item-title">' + esc(item.product_title) + '</p>' + variant +
          '<div class="cart-drawer-qty">' +
            '<button type="button" data-drawer-qty="minus" data-line="' + (i + 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-drawer-qty="plus" data-line="' + (i + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div><br>' +
          '<button type="button" class="quiet-link" data-drawer-remove data-line="' + (i + 1) + '">Remove</button>' +
        '</div>' +
        '<p class="cart-drawer-item-price">' + money(item.final_line_price) + '</p>' +
      '</div>';
    }).join('');
  }

  function refreshCart(openAfter) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (openAfter) setCartOpen(true);
        return cart;
      })
      .catch(function () { /* drawer keeps last state */ });
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { refreshCart(true); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { setCartOpen(false); });
  });
  if (overlay) overlay.addEventListener('click', function () { setCartOpen(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setCartOpen(false);
  });

  // Drawer qty + remove (event delegation)
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-drawer-qty]');
      var rmBtn = e.target.closest('[data-drawer-remove]');
      if (qtyBtn) {
        var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
        var delta = qtyBtn.getAttribute('data-drawer-qty') === 'plus' ? 1 : -1;
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var item = cart.items[line - 1];
            if (!item) return null;
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ line: line, quantity: Math.max(0, item.quantity + delta) })
            });
          })
          .then(function () { return refreshCart(false); })
          .catch(function () {});
      } else if (rmBtn) {
        var rline = parseInt(rmBtn.getAttribute('data-line'), 10);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: rline, quantity: 0 })
        }).then(function () { return refreshCart(false); }).catch(function () {});
      }
    });
  }

  // Add to cart from product form -> open drawer
  var productForm = document.querySelector('form[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = productForm.querySelector('[data-add-to-cart]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(productForm)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () { return refreshCart(true); })
        .catch(function () {
          // Fallback: regular form submit if the API fails
          productForm.submit();
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
        });
    });
  }

  /* ---------- Product gallery ---------- */
  var thumbs = document.querySelectorAll('[data-gallery-thumb]');
  var galleryImgs = document.querySelectorAll('[data-gallery-img]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var idx = thumb.getAttribute('data-gallery-thumb');
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      galleryImgs.forEach(function (img) {
        var active = img.getAttribute('data-gallery-img') === idx;
        img.classList.toggle('is-active', active);
        img.hidden = !active;
      });
    });
  });

  /* ---------- Variant selection ---------- */
  var productJsonEl = document.querySelector('[data-product-json]');
  if (productJsonEl && productForm) {
    var product = JSON.parse(productJsonEl.textContent);
    var variantInput = productForm.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var addPriceEl = document.querySelector('[data-add-price]');
    var addBtn = productForm.querySelector('[data-add-to-cart]');

    function currentVariant() {
      var selected = {};
      productForm.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var idx = fs.getAttribute('data-option-index');
        var checked = fs.querySelector('input:checked');
        if (checked) selected['option' + (parseInt(idx, 10) + 1)] = checked.value;
      });
      return product.variants.find(function (v) {
        return Object.keys(selected).every(function (k) { return v[k] === selected[k]; });
      });
    }

    function updateVariant() {
      var v = currentVariant();
      if (!v) return;
      if (variantInput) variantInput.value = v.id;
      var priceHtml = money(v.price);
      if (v.compare_at_price > v.price) {
        priceHtml = '<s class="price-was">' + money(v.compare_at_price) + '</s>' + priceHtml;
      }
      if (priceEl) priceEl.innerHTML = priceHtml;
      if (addPriceEl) addPriceEl.textContent = money(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (!v.available) addBtn.innerHTML = 'Sold out';
      }
      // selected value labels
      productForm.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var label = fs.querySelector('[data-option-selected]');
        var checked = fs.querySelector('input:checked');
        if (label && checked) label.textContent = '— ' + checked.value;
      });
    }

    productForm.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });
    updateVariant();
  }

  /* ---------- Quantity stepper (product page) ---------- */
  var qtyInput = document.querySelector('[data-qty-input]');
  if (qtyInput && productForm) {
    productForm.querySelector('[data-qty-minus]').addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
    });
    productForm.querySelector('[data-qty-plus]').addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
    });
  }

  /* ---------- v3.7: pause hero video for reduced motion ---------- */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.hero-video-bg').forEach(function (v) {
      v.pause();
      v.removeAttribute('autoplay');
    });
  }

  /* ---------- v3.7: customer orders marquee — auto-scroll, drag to take over ---------- */
  var marquee = document.querySelector('.orders-marquee');
  if (marquee) {
    var track = marquee.querySelector('.orders-track');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var x = 0;
    var dragging = false;
    var hoverPaused = false;
    var dragStartX = 0;
    var dragStartTranslate = 0;
    var SPEED = 0.7; /* px per frame */

    function halfWidth() { return track.scrollWidth / 2; }
    function render() { track.style.transform = 'translate3d(' + x + 'px,0,0)'; }

    function tick() {
      if (!dragging && !hoverPaused && !reduceMotion) {
        x -= SPEED;
        var h = halfWidth();
        if (h && x <= -h) x += h;
        render();
      }
      requestAnimationFrame(tick);
    }

    marquee.addEventListener('pointerdown', function (e) {
      dragging = true;
      dragStartX = e.clientX;
      dragStartTranslate = x;
      try { marquee.setPointerCapture(e.pointerId); } catch (err) {}
    });
    marquee.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      x = dragStartTranslate + (e.clientX - dragStartX);
      var h = halfWidth();
      if (h) {
        while (x > 0) x -= h;
        while (x <= -h) x += h;
      }
      render();
    });
    function endDrag() { dragging = false; }
    marquee.addEventListener('pointerup', endDrag);
    marquee.addEventListener('pointercancel', endDrag);

    marquee.addEventListener('mouseenter', function () { hoverPaused = true; });
    marquee.addEventListener('mouseleave', function () { hoverPaused = false; });

    requestAnimationFrame(tick);
  }
})();
